import integrationsClient, { type ApiDefinition } from '@/tsClient/servers/integrationsService';

type THIS_API = ApiDefinition['/submission-attempts/{id}/cancel']['POST'];
type Input = THIS_API['params'];
type Output = THIS_API['response'];

const cancelCaseSubmission = async ({ id }: Input): Promise<Output> => {
  const response = await integrationsClient.post(`/submission-attempts/${id}/cancel`);
  return response.data;
};

export default cancelCaseSubmission;
